import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmationService } from 'primeng/api';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';
import * as XLSX from "xlsx-js-style";
import { Router } from '@angular/router';

@Component({
  selector: 'contact',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './contact.component.html'
})

export class ContactComponent implements OnInit {

  /*
        RecordList - Search result list
        SelectedRecordList - User selected record (Multiple) in the result table
        SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: IContact[];
  public SelectedRecordList: IContact[];
  public SelectedRecord: IContact;
  public SelectedUserRecord: IUserProfile;
  public SelectedAttachmentList: IAttachmentValue[];
  public SelectedAttachmentRecord: IAttachmentValue;
  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchDnFieldHolder: any;
  public cols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;

  //  Code value list for List Box, add required code value list
  public DomainList: IDomainValue[];
  public DataRoleList: IDataRole[];
  public ProcessRoleList: IListValue[];
  public ActionRoleList: IListValue[];
  public ActiveFlagList: IListValue[];
  public AttachmentList: IAttachmentValue[];
  public UserAccountTypeList: IListValue[];
  public CompanyList: IListValue[];

  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";
  public loggedInContactId: string = "";

  public currentVertificationKey: string = "";
  public currentRegisterFlag: string = "";
  public currentInviteFlag: string = "";
  public currentTempCompany: string = "";
  public currentCompanyStatus: string = "";

  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";


  //excel variable
  excelRow: string[] = [];
  strLine: string;
  cellList: string[];
  lastRowNumber: number;

  /*
    action code security
*/
  public allowAdd: string = "N";

  /*
        sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
        softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';


  /*
        Major control variables
            FormTitle - Initial Form Title for the landing form
            PrimaryApiPath - Path for the API controller per component 
            ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
            AutoReload - control auto reload component    
  */
  FormTitle: String = "Work With Company Contact";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpContact/";
  CompanyApiPath: string = "api/BcpCompany/";
  UserProfileApiPath: string = "api/BcpUserProfile/";
  ListValueApiPath: string = "api/BcpListValue/";
  AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";
  AttachmentPath: string = "api/BcpAttachment/";
  TableSequenceApiPath: string = "api/BcpTableSequence/";
  SendEmailPath: string = "api/BcpEmailService/";
  SecurityApiPath: string = "api/BcpUserSecurityAction/";

  ShowAddForm: Boolean = false;
  ShowEditForm: Boolean = false;
  ShowNotAuthorizedForm: Boolean = false;
  SuccessUpload: Boolean = false;

  AutoReload: Boolean = true;

  scrollHeight: string = "";
  scrollWidth: string = "";

  public RecordCount: number = 0;

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;

  //Attachment related
  public uploadAttachment: boolean = false;
  public record: any;
  uploadFile: File;
  AttachmentAutoReload: Boolean = true;

  public resultMsgs: Message[] = [];
  public GenNextNumberFieldHolder: IGenNextNumber;
  public NextNumberOutput: INextNumber;
  public CompanyStatus: ICompanyStatus;
  public emailReturnStatus: boolean = false;
  public contactEmail: IContactEmail;

  confirmingEmail: string = "";
  checkedError: string = "";
  newRecordId: any;
  contactCount: any;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';


  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private bcp: CommonSerivce
    , private datePipe: DatePipe
    , private confirmationService: ConfirmationService
    , private _router: Router) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.UserProfileApiPath = originUrl + this.UserProfileApiPath;
    this.CompanyApiPath = originUrl + this.CompanyApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.TableSequenceApiPath = originUrl + this.TableSequenceApiPath;
    this.SendEmailPath = originUrl + this.SendEmailPath;
    this.SecurityApiPath = originUrl + this.SecurityApiPath;


    this.FormAccessRight = this.bcp.getAccessRightByProcess('CONTACT');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();
    this.loggedInContactId = this.bcp.getCurrentLoginUser();

    //get action security controls
    this.getSecurity();

    this.resetSearchField();
    this.FormTitle = "Work With Company Contact";
    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.ShowNotAuthorizedForm = false;

    this.getFirstPage();

    this.getCompanyList(this.bcp.getCurrentDomainId(), 'D');

    this.getListValue();
    //this.getData();

    //get all list value for drop down list
    this.getDomainList();
    this.getUserAccountTypeList("BCP");

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.SelectedUserRecord = null;
    this.InputErrorMsg = [];


    this.cols = [
      { field: 'actions', header: 'Actions', width: '100', size: '5' },
      { field: 'id', header: 'ID', width: '80', size: '5' },
      { field: 'domainId', header: 'Domain ID', width: '100', size: '10' },
      { field: 'companyCode', header: 'Company Code', width: '100', size: '10' },
      { field: 'fullName', header: 'Contact Name', width: '200', size: '10' },
      { field: 'email1', header: 'Email', width: '200', size: '10' },
      { field: 'contactId', header: 'Contact ID', width: '120', size: '10' },
      { field: 'phone1', header: 'Phone No.', width: '120', size: '10' },
      { field: 'department', header: 'Department', width: '150', size: '10' },
      { field: 'title', header: 'Job Title', width: '150', size: '10' },
      { field: 'activeFlag', header: 'Active', width: '80', size: '10' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.pdfColumns[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);

    this.attachmentCols = [
      { field: 'actions', header: 'Actions', width: '30', size: '5' },
      { field: 'id', header: 'Id', width: '60', size: '5' },
      { field: 'sourceRecordId', header: 'Source Record Id', width: '60', size: '5' },
      { field: 'displayName', header: 'File Name', width: '120', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '120', size: '5' }
    ];

  }

  ngOnInit() {

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

   }

  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------


  //to get required code list from Web API
  getListValue() {

    //get list value  Box
    this.http.get(this.UserProfileApiPath + "GetDataRole", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DataRoleList = result;
      });

    this.http.get(this.UserProfileApiPath + "GetProcessRole", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ProcessRoleList = result;
      });

  }


  async getSecurity() {
    //check for tender master creation
    let checkResult1 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/CTM1", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult1.allowAccess == "Y") {
      this.allowAdd = "Y";
    }
  }

  //get company status fields
  async getCompanyStatus(domainId, companyCode) {
    this.CompanyStatus = await this.http.get(this.CompanyApiPath + "GetCompanyStatus/" + domainId + "/" + companyCode, this.bcp.getHttpOptions())
      .map((response: any) => response).toPromise();
    this.currentVertificationKey = this.CompanyStatus.vertificationKey;
    this.currentRegisterFlag = this.CompanyStatus.registerFlag;
    this.currentInviteFlag = this.CompanyStatus.inviteFlag;
    this.currentTempCompany = this.CompanyStatus.tempCompany;
    this.currentCompanyStatus = this.CompanyStatus.companyStatus;
  }

  //determine what the first page should be shown
  async getFirstPage() {
    if (this.loggedInType != 'E') {
      this.getData();
    }
    else if (this.loggedInType == 'E') {
      await this.getCompanyStatus(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
      if (this.currentCompanyStatus == "ACTIVE") {
        this.getData();
      } else {
        this.ShowNotAuthorizedForm = true;
      }
    };
  }

  getData() {
    this.AutoReload = true;
    this.http.get(this.PrimaryApiPath + "GetByCompany/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentCompanyCode(), this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.RecordCount = this.RecordList.length;
        //console.log(this.RecordList);

        if (this.RecordList.length > 0) {
          for (var i = 0; i < this.RecordList.length; i++) {
            this.applyGlobalFilter();
            //Stop Loading Icon when finish fetching last record
            if (i == this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          //this.AutoReload = false;
        }

      });
  }


  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedRecord = data;
        this.SelectedRecord.activeFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.activeFlag);
        this.SelectedRecord.needUserAccount = this.bcp.convertYesNoToBoolean(this.SelectedRecord.needUserAccount);
        this.getCompanyList(this.SelectedRecord.domainId, 'D');
        //get user profile record
        if (this.SelectedRecord.needUserAccount) {
          this.http.get(this.UserProfileApiPath + "GetByLoginId/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.loginId, this.bcp.getHttpOptions())
            .subscribe((result: any) => {
              this.SelectedUserRecord = result;
            });
        };

      });

  }


  //get record by search field(s)
  getDataBySearchField() {
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    console.log(this.stringifyValue);
    this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.AutoReload = true;
        if (this.RecordList.length > 0) {
          this.applyGlobalFilter();
          for (var i = 0; i < this.RecordList.length; i++) {
            //Stop Loading Icon when finish fetching last record
            if (i == this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          //this.AutoReload = false;
        }
      });

  }


  //Get record ID for re-direct to edit page when click 'Save and Upload' (For upload Attachment)
  getIDbyData() {
    this.http.post(this.PrimaryApiPath + "GetID/Sec/" + this.bcp.getCurrentDataRole(), this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: Response) => response.json())
      .subscribe(data => {
        this.record = data;
        this.editRecord(this.record.id);
      });

  }


  exportExcel() {

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });

  }


    saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      });
  } 


    exportPdf() {
    const doc = new jsPDF({ orientation: "landscape" });
    var head = [];
    head[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);
    autoTable(doc, {
      headStyles: { fillColor: [0,0,0] },
      styles: { fillColor: [255, 255, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] }, 1: { halign: 'left', fillColor: [0, 255, 255] } },
      head: head,
      body: this.RecordList.map(e => Object.keys(e).map(k => e[k])),
      didDrawCell: (data) => {
        //console.log(data.column.index)
      },
    });

    doc.save('table.pdf');
    }


    findRecord() {
        this.RecordList = null;
        this.getDataBySearchField();
    }


  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');
    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
    this.SearchFieldHolder["companyCode"] = this.loggedInCompanyCode;

  }


  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
  }


  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);
  }


  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------


  addRecord() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedRecord = null;
    this.SelectedRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedRecord.domainId = "";
    this.SelectedRecord.contactId = "";
    this.SelectedRecord.companyCode = "";
    this.SelectedRecord.fullName = "";
    this.SelectedRecord.fullNameOther = "";
    this.SelectedRecord.businessUnit = "";
    this.SelectedRecord.title = "";
    this.SelectedRecord.department = "";
    this.SelectedRecord.addressLine1 = "";
    this.SelectedRecord.addressLine2 = "";
    this.SelectedRecord.addressLine3 = "";
    this.SelectedRecord.addressLine4 = "";
    this.SelectedRecord.postalCode = "";
    this.SelectedRecord.country = "";
    this.SelectedRecord.email1 = "";
    this.SelectedRecord.email2 = "";
    this.SelectedRecord.phoneArea1 = "";
    this.SelectedRecord.phone1 = "";
    this.SelectedRecord.phoneArea2 = "";
    this.SelectedRecord.phone2 = "";
    this.SelectedRecord.phoneArea3 = "";
    this.SelectedRecord.phone3 = "";
    this.SelectedRecord.phoneArea4 = "";
    this.SelectedRecord.phone4 = "";
    this.SelectedRecord.contactType = "";
    this.SelectedRecord.needUserAccount = "Y";
    this.SelectedRecord.userAccountType = "";
    this.SelectedRecord.activeFlag = "Y";
    this.SelectedRecord.primaryContact = "S";
    this.SelectedRecord.loginId = "";
    this.SelectedRecord.conflictOfInterest = "N";
    this.SelectedRecord.conflictFullName = "";
    this.SelectedRecord.conflictDepartment = "";
    this.SelectedRecord.conflictRelationship = "";
    this.SelectedRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.updateUser = "";
    this.SelectedRecord.updateDate = "";

    this.confirmingEmail = "";

    this.SelectedRecord.activeFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.activeFlag);
    this.SelectedRecord.needUserAccount = this.bcp.convertYesNoToBoolean(this.SelectedRecord.needUserAccount);

    //initialize the SelectedUserRecord as a new record, and assign default value as required
    this.SelectedUserRecord = null;
    this.SelectedUserRecord = JSON.parse('{"id": 0}');

    this.SelectedUserRecord.domainId = "";
    this.SelectedUserRecord.loginId = "";
    this.SelectedUserRecord.password = "";
    this.SelectedUserRecord.distinguishedName = "";
    this.SelectedUserRecord.fullName = "";
    this.SelectedUserRecord.department = "";
    this.SelectedUserRecord.title = "";
    this.SelectedUserRecord.email = "";
    this.SelectedUserRecord.phone = "";
    this.SelectedUserRecord.vip = "";
    this.SelectedUserRecord.processRole = "";
    this.SelectedUserRecord.dataRole = "";
    this.SelectedUserRecord.actionRole = "";
    this.SelectedUserRecord.alphaName = "";
    this.SelectedUserRecord.errorAttempt = 0;
    this.SelectedUserRecord.businessUnit = "";
    this.SelectedUserRecord.controlFlag01 = "";
    this.SelectedUserRecord.controlFlag02 = "";
    this.SelectedUserRecord.controlFlag03 = "";
    this.SelectedUserRecord.companyCode = "";
    this.SelectedUserRecord.companyDomain = "";
    this.SelectedUserRecord.userId = "";
    this.SelectedUserRecord.accountType = "";
    this.SelectedUserRecord.staffNumber = "";
    this.SelectedUserRecord.company = "";
    this.SelectedUserRecord.team = "";
    this.SelectedUserRecord.grading = "";
    this.SelectedUserRecord.jdeAn81 = 0;
    this.SelectedUserRecord.jdeAn82 = 0;
    this.SelectedUserRecord.jdeAn83 = 0;
    this.SelectedUserRecord.jdeAn84 = 0;
    this.SelectedUserRecord.verifyCode = "";
    this.SelectedUserRecord.activeFlag = "";
    this.SelectedUserRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedUserRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedUserRecord.updateUser = "";
    this.SelectedUserRecord.updateDate = "";

    if (this.loggedInType != "B") {
      this.SelectedRecord.domainId = this.bcp.getCurrentDomainId();
      this.SelectedRecord.companyCode = this.bcp.getCurrentCompanyCode();
      this.SelectedUserRecord.processRole = this.bcp.getCurrentProcessRole();
      this.SelectedUserRecord.dataRole = this.bcp.getCurrentDataRole();
      this.SelectedUserRecord.actionRole = this.bcp.getCurrentActionRole();
      this.getUserAccountType(this.SelectedRecord.domainId, this.SelectedRecord.companyCode);
    };

    this.FormTitle = "Contact Information Revision";
    this.ShowAddForm = true;
    this.ShowEditForm = false;
  }


  editRecord(recordId) {
    this.SelectedRecord = null;
    this.SelectedUserRecord = null;
    this.getDataById(recordId);
    this.getAttachmentList(recordId);

    this.FormTitle = "Contact Information Revision";// - ID = " + recordId;
    this.ShowAddForm = false;
    this.ShowEditForm = true;

  }


  saveRecord() {
    if (this.SelectedRecord.id == 0) {
      //get contactid
      //this.SelectedRecord.contactId = this.bcp.upper(this.SelectedRecord.email1);
      //get loginid
      //this.SelectedRecord.loginId = this.SelectedRecord.email1.substring(0, this.SelectedRecord.email1.indexOf("@"));
      //this.SelectedRecord.loginId = this.SelectedRecord.companyCode.trim() + "_" + this.SelectedRecord.loginId.toUpperCase();
    };
    this.stringifyValue = JSON.stringify(this.SelectedRecord);
    //alert(this.stringifyValue);
    if (this.SelectedRecord.id == 0) {
      this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          async (result: any) => {
            //send email to new user
            let checkResult = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/CTM1", this.bcp.getHttpOptions())
              .map((response: any) => JSON.parse(response.toString())).toPromise();
            if (checkResult.applyEmail == "Y") {
              this.sendNewContactEmail();
            }
            if (this.SelectedRecord.needUserAccount == "Y") {
              this.saveUserProfileRecord();
            };
            this.confirmingEmail = "";
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            this.FormTitle = "Work With Company Contact";
            this.findRecord();
          },
          (err) => {

            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });

    }

    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            if (this.SelectedRecord.needUserAccount == "Y") {
              this.saveUserProfileRecord();
            };
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            this.FormTitle = "Work With Company Contact";
            this.findRecord();
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }

          });

    }

  }


  saveUserProfileRecord() {
    if (this.SelectedUserRecord.id == 0) {
      this.SelectedUserRecord.domainId = this.SelectedRecord.domainId;
      this.SelectedUserRecord.loginId = this.SelectedRecord.loginId;
      this.SelectedUserRecord.password = "123";
      this.SelectedUserRecord.distinguishedName = this.SelectedRecord.loginId;
      this.SelectedUserRecord.vip = "N";
      this.SelectedUserRecord.processRole = this.bcp.getCurrentProcessRole();
      this.SelectedUserRecord.dataRole = this.bcp.getCurrentDataRole();
      this.SelectedUserRecord.actionRole = this.bcp.getCurrentActionRole();
      this.SelectedUserRecord.alphaName = this.bcp.upper(this.SelectedRecord.email1.split('@')[0]);
      this.SelectedUserRecord.companyDomain = this.bcp.upper(this.SelectedRecord.email1.split('@')[1]);
      this.SelectedUserRecord.companyCode = this.SelectedRecord.companyCode;
      this.SelectedUserRecord.userId = this.SelectedRecord.loginId;
      if (this.SelectedRecord.userAccountType == "D") {
        this.SelectedUserRecord.accountType = "DOMAIN"
      } else if (this.SelectedRecord.userAccountType == "E") {
        this.SelectedUserRecord.accountType = "ENDUSER"
      }
    };
    //this.SelectedUserRecord.fullName = this.SelectedRecord.fullName;
    //this.SelectedUserRecord.department = this.SelectedRecord.department;
    //this.SelectedUserRecord.title = this.SelectedRecord.title;
    //this.SelectedUserRecord.email = this.SelectedRecord.email1;
    //this.SelectedUserRecord.phone = this.SelectedRecord.phone1;
    this.SelectedUserRecord.activeFlag = this.SelectedRecord.activeFlag;
    this.SelectedUserRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedUserRecord.updateUser = this.bcp.getCurrentLoginUser();

    this.stringifyValue = JSON.stringify(this.SelectedUserRecord);
    //alert(this.stringifyValue);
    if (this.SelectedUserRecord.id == 0) {
      this.http.post(this.UserProfileApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });

    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.UserProfileApiPath + "" + this.SelectedUserRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }

          });

    }

  }


  //Return to Inquiry Form
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        //this.uploadAttachment = false;
        this.preProcessingAndSave();

      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  deleteRecord(pId, pLoginId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this contact?',
      accept: () => {
        this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.http.delete(this.UserProfileApiPath + "DeleteByLoginId/" + pLoginId, this.bcp.getHttpOptions())
                .subscribe(
                  (data: any) => {
                    //do nothing
                  });

              this.findRecord();

            });

      },

      reject: () => {
        //Do Nothing
      }

    });

  }


  cancel() {
    this.findRecord();
    this.SelectedRecord = null;
    this.SelectedUserRecord = null;
    this.InputErrorMsg = [];
    this.confirmingEmail = "";

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.FormTitle = "Work With Company Contact";

  }

  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------

  getDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DomainList = result;
      });
  }

  getUserAccountTypeList(selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode2/" + selectedDomain + "/USER_AC_TYPE", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.UserAccountTypeList = result;
      });
  }

  getUserAccountType(selectedDomain, selectedCompanyCode) {
    if (selectedDomain == "BCP") {
      this.SelectedRecord.userAccountType = "B";
    } else {
      this.http.get(this.CompanyApiPath + "GetCompanyType/" + selectedDomain + "/" + selectedCompanyCode, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.SelectedRecord.userAccountType = result;
        });
    };
  }

  getCompanyList(selectedDomain, selectedCompanyType) {
    this.http.get(this.CompanyApiPath + "GetCompanyListByType/" + selectedDomain + "/" + selectedCompanyType, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyList = result;
      });
  }

  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  async generateExcelReport() {
    let contactRec: IContact;
    let contactList: IContact[];

    let fileReader = new FileReader();
    let strLine: string;
    let timeStamp: string;
    const url = "https://sheetjs.com/data/executive.json";

    //get the master data
    contactList = this.RecordList;
    timeStamp = this.bcp.convertDateToString(null, true).toString();

    //initial the worksheet and workbook
    //this.strLine = "";
    //this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "ContactReport");

    //if then else for easy to collapase the contents only
    //Header Fields
    if (1 == 1) {
      //---------------------------------------------
      //List Headings
      //---------------------------------------------
      if (this.FormAccessRight == "RW") {
        this.strLine = "Domain~ Company Code~ Contact Name~ Email~ Phone No.~ Mobile No.";
        this.strLine = this.strLine + "~ Department~ Job Title~ Active";
      } else {
        this.strLine = "Company Code~ Contact Name~ Email~ Phone No.~ Mobile No.";
        this.strLine = this.strLine + "~ Department~ Job Title~ Active";
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    //output the record details
    for (var i = 0; i < contactList.length; i++) {

      if (this.FormAccessRight == "RW") {
        this.strLine = "" + contactList[i].domainId
          + "~" + contactList[i].companyCode + "~" + contactList[i].fullName
          + "~" + contactList[i].email1 + "~" + contactList[i].phone1
          + "~" + contactList[i].phone2 + "~" + contactList[i].department
          + "~" + contactList[i].title + "~" + contactList[i].activeFlag;
      } else {
        this.strLine = "" + ""
          + "~" + contactList[i].companyCode + "~" + contactList[i].fullName
          + "~" + contactList[i].email1 + "~" + contactList[i].phone1
          + "~" + contactList[i].phone2 + "~" + contactList[i].department
          + "~" + contactList[i].title + "~" + contactList[i].activeFlag;
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "ContactList_" + timeStamp + ".xlsx", { compression: true });
  }

  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    dataArray = this.strLine.split("~");
    //console.log("string is " + dataArray);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }

  //Formet Excel Cell
  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 8 }, { width: 14 }, { width: 14 }, { width: 20 }, { width: 20 }, //ABCDE
      { width: 30 }, { width: 30 }, { width: 30 }, { width: 25 }, { width: 10 }, //FGHIJ
      { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, //KLMNO
      { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, //PQRST
      { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 } //UVWXYZ
    ];
    worksheet["!cols"] = wscols;

    this.lastRowNumber = data.length + 1;
  }

  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    tmpList = [];
    this.addRangeToCellList("A", 1, "I", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //amount with 2dp
    //aware if any space before the cell value
    tmpList = ["C5"];
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

    console.log(this.cellList);
  }

  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }

  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      fgColor: { rgb: "e6f7eb" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }

  }
  //formatCell end

  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }

  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }

  //-----------------------------------------------------------------------------
  //                                  Attachment
  //-----------------------------------------------------------------------------

  //set file object for upload when file is selected
  selectUploadFile(event: any) {
    for (let file of event.files) {
      this.uploadFile = file;
    }
  }


  //upload the selected attachment
  processUploadFile(sourceRecordId: any) {
    console.log(">>> xxx >>> " + sourceRecordId);

    this.SuccessUpload = false;
    this.AttachmentAutoReload = false;

    //let fi = event.srcElement;
    //if (fi.files && fi.files[0]) {
    if (this.uploadFile) {

      //let fileToUpload = fi.files[0];
      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.bcp.getCurrentDomainId());
      formData.append("SourceTableName", "Contact");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();
      // DON'T SET THE Content-Type to multipart/form-data,
      //You'll get the Missing content-type boundary error
      //let options = new RequestOptions();
      console.log(">>> 555 >>> " + sourceRecordId);

      this.http.post("api/BcpAttachment/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe(r => {
          console.log(r);

          this.SuccessUpload = true;
          //this.AttachmentAutoReload = false;
          this.getAttachmentList(sourceRecordId);
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
        });
    }

    /*if (this.SuccessUpload == true) {
      //alert("Attachment Upload Successfully");
      //this.uploadFile = null;
      this.getAttachmentList(sourceRecordId);
    }*/
  }

    //download attachment by click on the filename
    downloadFile(recordID, fileName) {
      //this.http.get(this.AttachmentPath + "File/" + recordID, { 'responseType': 'blob'} )
      this.http.get(this.AttachmentPath + "File/" + recordID, this.bcp.getHttpOptionsAtt())
        .catch((err) => { return Observable.throw(err); })
        .subscribe((result: any) => {
               if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
                  console.log("window" + result);
                  var blob = new Blob([result]);
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                  console.log("other" + result);

                 var a = document.createElement("a");
                 var blob = new Blob([result]);
                  a.href = URL.createObjectURL(result);
                  a.download = fileName;
                  // start download
                  a.click();
                }
            })
            
    }   

    //delete the attachment 
    deleteAttachment(recordID) {
        if (window.confirm('Do you confirm to delete the selected record  ?')) {
          this.http.delete(this.AttachmentPath + "Delete/" + recordID, this.bcp.getHttpOptions()).subscribe((result:any) => {
                this.getAttachmentList(this.SelectedRecord.id);
            });
            //alert("Attachment Deleted Successfully");
        }
    }


    //Re-direct from add page to edit page to upload attachment
    saveThenUploadAttachment() {
      this.uploadAttachment = true;
      this.saveRecord()
    }


  getAttachmentList(recordID) {
    this.AttachmentList = [];

    this.http.get(this.AttachmentPath + "List/" + this.bcp.getCurrentDomainId() + "/Contact/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AttachmentList = result;
        //console.log("aatachment " + this.AttachmentList);

        if (this.AttachmentList.length > 0) {
          this.AttachmentAutoReload = true;
        }
      });
  }


    //sorting event trigger, default is sorting by id
    changeSort(event) {
        if (!event.order) {
            this.sortF = 'id';
        } else {
            this.sortF = event.field;
        }
    }


  //-----------------------------------------------------------------------------
  //                      Email Functions
  //-----------------------------------------------------------------------------

  sendNewContactEmail() {
    this.contactEmail = {};
    this.contactEmail.inputDomain = this.bcp.getCurrentDomainId();
    this.contactEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.contactEmail.companyCode = this.SelectedRecord.companyCode;
    this.contactEmail.userName = this.SelectedRecord.fullName;
    this.contactEmail.email = this.SelectedRecord.email1;
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.contactEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendNewContactEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }


  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  clearAllMessage() {
    this.InputErrorMsg = [];
    this.resultMsgs = [];

  }

  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9,_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }


  async preProcessingAndSave() {
    //Clear Search Form Error Message
    this.clearAllMessage();
    this.checkedError = 'N';

    //check domain
    if (this.SelectedRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain is missing   ' });
    };

    //check company code
    if (this.SelectedRecord.companyCode.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Company is missing   ' });
    };

    //check contact name
    if (this.SelectedRecord.fullName.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contact Name is missing   ' });
    };

    //check phone number
    if (this.SelectedRecord.phone1.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Phone Number is missing   ' });
    };

    //check email and duplication
    if (this.SelectedRecord.email1.trim() == "" || !this.isValidEmail(this.SelectedRecord.email1)) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Email is missing / not valid   ' });
    } else if (this.SelectedRecord.id == 0) {
      this.newRecordId = 0;
      this.newRecordId = await this.http.get(this.PrimaryApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + this.bcp.upper(this.SelectedRecord.email1), this.bcp.getHttpOptions()).toPromise();
      if (this.newRecordId > 0) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contact is duplicated   ' });
      }
    };

    //check confirming email
    if (this.bcp.upper(this.SelectedRecord.email1) != this.bcp.upper(this.confirmingEmail) && this.SelectedRecord.id == 0) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Confirming email does not match   ' });
    };

    //check number of contacts for end user only
    if (this.SelectedRecord.userAccountType == "E") {
      if (this.SelectedRecord.activeFlag) {
        if (this.SelectedRecord.id == 0) {
          this.SelectedRecord.contactId = "TEMPID";
        }
        this.contactCount = 0;
        this.contactCount = await this.http.get(this.PrimaryApiPath + "GetContactCount/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.companyCode + "/" + this.SelectedRecord.contactId, this.bcp.getHttpOptions()).toPromise();
        if (this.contactCount >= 3) {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Too many contacts are created   ' });
        }
        if (this.SelectedRecord.contactId == "TEMPID") {
          this.SelectedRecord.contactId = "";
        }
      }
    }

    //assign default and check unique if above checking passed
    if (this.checkedError == 'N') {
      //get new loginId for contact record
      if (this.SelectedRecord.contactId.trim() == "") {
        if (this.SelectedRecord.userAccountType == "D") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'UP02', '');
          this.SelectedRecord.contactId = this.NextNumberOutput.nextKey;
        } else if (this.SelectedRecord.userAccountType == "E") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'UP03', '');
          this.SelectedRecord.contactId = this.NextNumberOutput.nextKey;
        }
        if (this.NextNumberOutput.nextKey == "NOT_FOUND") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Default Next Number is not setup   ' });
        } else if (this.NextNumberOutput.nextKey == "MAX_NUMBER") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Maximum Next Number is reached   ' });
        } else {
          this.SelectedRecord.loginId = this.SelectedRecord.contactId;
          this.SelectedRecord.activeFlag = "Y";
          this.SelectedRecord.primaryContact = "S";
        }
      }
      this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();
      this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
      //convert check box field value from boolean to character
      this.SelectedRecord.needUserAccount = this.bcp.convertBooleanToYesNo(this.SelectedRecord.needUserAccount);
      this.SelectedRecord.activeFlag = this.bcp.convertBooleanToYesNo(this.SelectedRecord.activeFlag);
    }


    //check unique if above checking passed
    if (this.checkedError == 'N') {
      //check new (contact id or email) unique
      let tmpApiString2: string = "";
      tmpApiString2 = JSON.stringify(this.SelectedRecord);
      //console.log("temApiString is " + tmpApiString2);
      let checkResult2 = await this.http.post(this.PrimaryApiPath + "ValidateKeyFields/", tmpApiString2, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult2.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'ContactId is duplicated   ' });
      }
      if (checkResult2.EmailFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Email is duplicated   ' });
      }
    };

    //save record if no error
    if (this.checkedError == 'N') {
      this.saveRecord();
    };
  };


  //getNextNumber for new contact record
  async genNextNumber(domainId: string, tableKey: string, inputDate: any) {
    this.NextNumberOutput = null;
    this.NextNumberOutput = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder = null;
    this.GenNextNumberFieldHolder = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder.domainId = domainId;
    this.GenNextNumberFieldHolder.tableKey = tableKey;
    this.GenNextNumberFieldHolder.inputDate = inputDate;
    this.GenNextNumberFieldHolder.updateUser = this.bcp.getCurrentLoginUser();
    this.GenNextNumberFieldHolder.updateDate = this.bcp.getCurrentDateTime();
    this.stringifyValue = JSON.stringify(this.GenNextNumberFieldHolder);
    this.NextNumberOutput = await this.http.post(this.TableSequenceApiPath + "GenNextNumber/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    //console.log("NextNumberOutput is " + this.NextNumberOutput);
    //console.log("nextKey is " + this.NextNumberOutput.nextKey);
  }

}

interface IContact {
  id?;
  domainId?;
  contactId?;
  companyCode?;
  fullName?;
  fullNameOther?;
  businessUnit?;
  title?;
  department?;
  addressLine1?;
  addressLine2?;
  addressLine3?;
  addressLine4?;
  postalCode?;
  country?;
  email1?;
  email2?;
  phoneArea1?;
  phone1?;
  phoneArea2?;
  phone2?;
  phoneArea3?;
  phone3?;
  phoneArea4?;
  phone4?;
  contactType?;
  needUserAccount?;
  userAccountType?;
  activeFlag?;
  primaryContact?;
  loginId?;
  conflictOfInterest?;
  conflictFullName?;
  conflictDepartment?;
  conflictRelationship?;
  createUser?;
  createDate?;
  updateDate?;
  updateUser?;
}

interface IUserProfile {
  id?;
  domainId?;
  loginId?;
  password?;
  distinguishedName?;
  fullName?;
  department?;
  title?;
  email?;
  phone?;
  vip?;
  processRole?;
  dataRole?;
  actionRole?;
  alphaName?;
  errorAttempt?;
  businessUnit?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  companyCode?;
  companyDomain?;
  userId?;
  accountType?;
  staffNumber?;
  company?;
  team?;
  grading?;
  jdeAn81?;
  jdeAn82?;
  jdeAn83?;
  jdeAn84?;
  verifyCode?;
  activeFlag?;
  createUser?;
  createDate?;
  updateDate?;
  updateUser?;
}


interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
  label?;
  value?;
}

interface IAttachmentValue {
  filePath?;
  id?;
  domainId?;
  sourceTable?;
  sourceRecordId?;
  actualFileName?;
  displayName?;
  createDate?;
  updateUser?;
  updateDate?;
}

interface SelectItem {
}

interface Message {
}

interface IDomainValue {
  label?;
  value?;
}

interface ICodeValue {
  label?;
  value?;
}

interface IGenNextNumber {
  domainId?;
  tableKey?;
  year?;
  inputDate?;
  updateUser?;
  updateDate?;
}

interface INextNumber {
  nextNumber?;
  nextKey?;
}

interface ICompanyStatus {
  vertificationKey?;
  registerFlag?;
  inviteFlag?;
  tempCompany?;
  companyStatus?;
}

interface IContactEmail {
  inputDomain?;
  inputUser?;
  companyCode?;
  userName?;
  email?;
}
